import { apiInstance } from '../apiInstance';
import { protectedResources } from '../../msalAuthConfig';

const headers = {
    'Content-Type': 'application/json',
};

const notificationApi = {
    GetCompanyNotificationsByTarget: (id, target) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/${target}/notifications`,
            headers,
        })
    },
    CreateNotification: async (data) => {
        return await apiInstance({
            method: 'POST',
            url: `${protectedResources.apiNotification.endpoint}/`,
            headers,
            data,
        });
    },
    UpdateNotificationStatus: async (data, status) => {
        return await apiInstance({
            method: 'PUT',
            url: `${protectedResources.apiNotification.endpoint}/status/${status}`,
            headers,
            data,
        });
    }
}

export default notificationApi;
